import React from "react";
import styles from '../styles/maskDot.module.scss';

interface Props {
    maskedString: string;
}

const formatToGroups = (str: string): string[] => {
    const cleaned = str.replace(/\s+/g, '');
    const groups: string[] = [];
    for (let i = 0; i < cleaned.length; i += 4) {
        groups.push(cleaned.slice(i, i + 4));
    }
    return groups;
};

const MaskDot = ({ maskedString }: Props) => {
    const cleaned = maskedString.replace(/\s+/g, '');
    const isMasked = cleaned.includes('*');
    const groups = formatToGroups(cleaned);

    return (
        <div className={styles.container}>
            <div className={styles.dotWrapper}>
                {groups.map((group, groupIdx) => (
                    <div key={groupIdx} className={styles.group}>
                        {isMasked ? (
                            // 如果是掩码格式，非最后一组显示圆点，最后一组有明文则不显示圆点
                            groupIdx === groups.length - 1 && !group.includes('*')
                                ? null
                                : [...group].map((_, i) => <span key={i} className={styles.dot} />)
                        ) : (
                            // 纯数字则直接显示明文
                            <span className={styles.value}>{group}</span>
                        )}
                    </div>
                ))}
            </div>
            {/* 如果是掩码格式，显示最后一组明文 */}
            {isMasked && !groups[groups.length - 1].includes('*') && (
                <span className={styles.value}>{groups[groups.length - 1]}</span>
            )}
        </div>
    );
};

export default MaskDot;
